module.exports = RedNaoFormBuilder.default('FormBuilder/Fields/Core/FBFieldBase.options');